import { Injectable } from "@angular/core";
import { addDays, differenceInDays, format, parse, subDays } from "date-fns";

@Injectable({
  providedIn: "root",
})
export class DateService {
  constructor() {}

  // Formatear una fecha
  formatDate(date: Date | string, dateFormat: string): string {
    return format(new Date(date), dateFormat);
  }

  // Parsear una fecha en formato ISO
  parseDate(dateString: string): Date {
    return parse(dateString, "yyyy-MM-dd", new Date());
  }

  // Añadir días a una fecha
  addDaysToDate(date: Date | string, days: number): Date {
    return addDays(new Date(date), days);
  }

  // Restar días a una fecha
  subtractDaysFromDate(date: Date | string, days: number): Date {
    return subDays(new Date(date), days);
  }

  // Diferencia en días entre dos fechas
  differenceInDaysBetweenDates(
    date1: Date | string,
    date2: Date | string
  ): number {
    return differenceInDays(new Date(date1), new Date(date2));
  }
}
